import styles from "./InfoAlert.module.css";

interface Props {
  message: string;
  icon?: "info" | "lock";
}

function InfoAlert({ message, icon = "info" }: Props) {
  return (
    <div className={styles.infoAlert}>
      <div className={`narmi-icon-${icon} ${styles.infoAlertIcon}`} />
      <span>{message}</span>
    </div>
  );
}

export { InfoAlert };
